import type { EnumObject } from "./EnumObject.js";
import type { EnumType } from "./EnumType.js";
import { values } from "./values.js";

/**
 * Take a list of key-value pairs and create a record of { key: value }.
 * Asserts that the keys are exactly 1:1 with an enum.
 */
export function createRecordFromEntries<const Enum extends EnumType, const Value>(
	enumObj: EnumObject<Enum>,
	entries: readonly [Enum, Value][],
): Record<Enum, Value> {
	const vals = values(enumObj);
	const map: Partial<Record<Enum, Value>> = {};
	if (entries.length !== vals.length) {
		throw new Error("Entry count does not match");
	}
	for (const [key, value] of entries) {
		if (key in map) {
			throw new Error("Duplicate key found");
		}
		map[key] = value;
	}
	return map as Record<Enum, Value>;
}
